import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
  Divider,
  Stack,
  Chip,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import DescriptionIcon from "@mui/icons-material/Description";
import VisibilityIcon from "@mui/icons-material/Visibility";

const AttachmentModal = ({ open, order, onClose, onPreview }) => {
  if (!order) return null;

  const uploadedAttachments =
    order.attachments?.filter((file) => file.status !== "Required") || [];

  const requiredAttachments =
    order.attachments?.filter((file) => file.status === "Required") || [];

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Typography variant="h6">Attachments</Typography>

            <Typography variant="body2" color="text.secondary">
              Order: {order.order_number || "—"}
            </Typography>
          </Box>

          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent>
        {/* Uploaded Files */}
        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
          Uploaded Files
        </Typography>

        {uploadedAttachments.length > 0 ? (
          <Stack spacing={1}>
            {uploadedAttachments.map((file) => (
              <Box
                key={file.id}
                onClick={() => onPreview(file)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  p: 1.2,
                  border: "1px solid",
                  borderColor: "divider",
                  borderRadius: 1,
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: "action.hover",
                  },
                }}
              >
                <DescriptionIcon fontSize="small" color="action" />

                <Typography variant="body2" sx={{ flex: 1 }} noWrap>
                  {file.title || file.file_title || "Attachment"}
                </Typography>

                <VisibilityIcon fontSize="small" color="action" />
              </Box>
            ))}
          </Stack>
        ) : (
          <Typography variant="body2" color="text.secondary">
            No uploaded files.
          </Typography>
        )}

        <Divider sx={{ my: 3 }} />

        {/* Required Files */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            mb: 1,
          }}
        >
          <Typography variant="subtitle1" fontWeight={600}>
            Required Files
          </Typography>

          <Chip
            label={requiredAttachments.length}
            size="small"
            color="warning"
          />
        </Box>

        {requiredAttachments.length > 0 ? (
          <Stack spacing={1}>
            {requiredAttachments.map((file) => (
              <Box
                key={file.id}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  p: 1.2,
                  border: "1px solid",
                  borderColor: "divider",
                  borderRadius: 1,
                }}
              >
                <DescriptionIcon fontSize="small" color="warning" />

                <Typography variant="body2" sx={{ flex: 1 }}>
                  {file.file_title || file.title || "Required Attachment"}
                </Typography>

                <Chip
                  label="Required"
                  size="small"
                  color="warning"
                  variant="outlined"
                />
              </Box>
            ))}
          </Stack>
        ) : (
          <Typography variant="body2" color="text.secondary">
            No required files.
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default AttachmentModal;
